module.exports = __webpack_public_path__ + "img/sustainabilityGold@2x.49744f6.jpg";